import type { Color } from 'src/types/theme';

export const yellow: Color = {
  50: '#fff4c7',
  100: '#ffeeac',
  200: '#ffe47a',
  300: '#ffdc52',
  400: '#ffd429',
  500: '#ffcc00',
  600: '#d4ab08',
  700: '#8f7200',
  800: '#574500',
  900: '#2e2500',
};
